import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// VITE_APPINSIGHTS_CONNECTION_STRING is set at build time from the
// AppInsightsConnectionString variable group entry. If the pipeline
// variable substitution misses (e.g. the variable group entry isn't
// defined), Azure Pipelines bakes the literal placeholder string
// "$(AppInsightsConnectionString)" into the bundle — non-empty, but
// not a valid connection string. The SDK then throws "Please provide
// instrumentation key" during loadAppInsights() and the unhandled
// exception kills the React mount, leaving a blank page.
//
// Require the string to actually look like a connection string
// (must include InstrumentationKey=…) before initializing. Anything
// else is treated as "telemetry disabled".
const rawConnectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '';
const connectionString = rawConnectionString.includes('InstrumentationKey=')
  ? rawConnectionString
  : '';

function initAppInsights(): ApplicationInsights | null {
  if (!connectionString) return null;
  try {
    const ai = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
      },
    });
    ai.loadAppInsights();
    ai.context.application.ver = '2.0.0';
    ai.context.user.id = 'anonymous'; // overridden post-login
    ai.addTelemetryInitializer((envelope) => {
      if (envelope.tags) {
        envelope.tags['ai.cloud.role'] = 'kairos-web';
        envelope.tags['ai.cloud.roleInstance'] = window.location.hostname;
      }
    });
    ai.trackPageView();
    return ai;
  } catch (err) {
    // Telemetry init is best-effort. Never let a misconfigured connection
    // string take down the SPA — log it and continue with telemetry off.
    console.warn('AppInsights init failed; telemetry disabled:', err);
    return null;
  }
}

export const appInsights = initAppInsights();
